function getAllTiersIdFournisseur(indexationTiers, previousIndexationTiers, tiersType) {
  let tiersIds = indexationTiers
    .filter((ind) => {
      return ind.tiersType === tiersType && ind.specialisationTiersId === null;
    })
    .map((ind) => ind.tiersId);
  if (!previousIndexationTiers) return [...new Set(tiersIds)];
  tiersIds = tiersIds.concat(previousIndexationTiers.filter((ind) => {
    return ind.tiersType === tiersType;
  }).map((ind) => ind.tiersId));
  return [...new Set(tiersIds)];
}

function createObjectIndexationTiers(index, previousIndex, tiersId) {
  const indexTiers = index.find((ind) => {
    return ind.tiersId === tiersId && ind.specialisationTiersId === null;
  });
  const previousIndexTiers = previousIndex ? previousIndex.find((ind) => {
    return ind.tiersId === tiersId && ind.specialisationTiersId === null;
  }) : null;
  return {
    tiersId: tiersId,
    nomCommercial: indexTiers ? indexTiers.tiers.nomCommercial
      : previousIndexTiers.tiers.nomCommercial,
    valueYearSelect: indexTiers ? indexTiers.pourcentageIndexationParDefaut : null,
    valueYearBeforeSelect: previousIndexTiers
      ? previousIndexTiers.pourcentageIndexationParDefaut : null,
    haveSpe: index.some((ind) => {
      return ind.tiersId === tiersId && ind.specialisationTiersId !== null;
    }),
  };
}

export default function genererTabIndexationTiers(indexation, previousIndexation, tiersType) {
  if (!indexation) return [];
  const tiersIdFournisseur = getAllTiersIdFournisseur(
    indexation.indexationTiers,
    previousIndexation ? previousIndexation.indexationTiers : null,
    tiersType,
  );
  const indexationTab = [];
  tiersIdFournisseur.forEach((tiersId) => {
    indexationTab.push(createObjectIndexationTiers(
      indexation.indexationTiers,
      previousIndexation ? previousIndexation.indexationTiers : null,
      tiersId,
    ));
  });
  indexationTab.sort((a, b) => {
    return a.nomCommercial.localeCompare(b.nomCommercial);
  });
  return indexationTab;
}
